// extracted by mini-css-extract-plugin
export default {"table":"sales-transaction_table__IuLZI"};